"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadFont = void 0;
const remotion_1 = require("remotion");
const get_font_format_1 = require("./get-font-format");
const loadFont = async ({ family, url, ascentOverride, descentOverride, display, featureSettings, lineGapOverride, stretch, style, unicodeRange, weight, format, variant, }) => {
    const waitForFont = (0, remotion_1.delayRender)(`Loading font ${family} (url: ${url}, format: ${format}, weight: ${weight}, style: ${style}, variant: ${variant}, ascentOverride: ${ascentOverride}, descentOverride: ${descentOverride}, display: ${display}, featureSettings: ${featureSettings}, lineGapOverride: ${lineGapOverride}, stretch: ${stretch}, unicodeRange: ${unicodeRange})`);
    try {
        const fontFormat = format !== null && format !== void 0 ? format : (0, get_font_format_1.getFontFormat)(url);
        const font = new FontFace(family, `url('${url}') format('${fontFormat}')`, {
            ascentOverride,
            descentOverride,
            display,
            featureSettings,
            lineGapOverride,
            stretch,
            style,
            unicodeRange,
            weight,
            // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
            // @ts-ignore variant is not in the FontFace constructor
            variant,
        });
        await font.load();
        document.fonts.add(font);
        (0, remotion_1.continueRender)(waitForFont);
    }
    catch (err) {
        (0, remotion_1.cancelRender)(err);
    }
};
exports.loadFont = loadFont;
